<template>
  <div class="vx-row">
    <div class="w-full vx-col">

      <vx-card :title="'MANAGE NOTIFICATIONS'" class="">

        <div id="notification-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="notifications">
              <template slot="thead">
                <vs-th width="30%">NAME</vs-th>
                <vs-th width="10%">USER COUNT IN DEPARTMENTS</vs-th>
                <vs-th width="10%">USER COUNT</vs-th>
                <vs-th width="20%">UPDATED BY</vs-th>
                <vs-th width="20%">UPDATED AT</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(tr.id)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].users_in_departments }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].users_count }}
                  </vs-td>

                  <vs-td :data="data[indextr].updated_by">
                    {{ data[indextr].updated_by || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].updated_at">
                    {{ data[indextr].updated_at ? __dateTimeFormatter(data[indextr].updated_at)  : 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>

          </div>
        </div>
      </vx-card>
    </div>
    <update-notification-manage-pop-up ref="updateNotificationManagePopUp"/>
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory';
  import UpdateNotificationManagePopUp from "@/components/popups/settings/notifications/UpdateNotificationManagePopUp";

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import { defaultPagination, perPageList } from "@/constants/config";

  const NotificationRepository = RepositoryFactory.get('notification');

  export default {
    name: "NotificationSettings",
    data() {
      return {
        notifications: [],
        page: 1,
        total: 0,
        meta: {},
        sort: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      UpdateNotificationManagePopUp
    },
    methods: {
      async refreshData() {
        await this.fetchNotificationManageList()
      },
      async fetchNotificationManageList() {
        await this.$vs.loading({
          container: '#notification-list-table',
          scale: 0.45
        })
        try {
          const {data} = await NotificationRepository.getAllNotificationManageList(this.page, this.perPage)
          this.notifications =  data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#notification-list-table > .con-vs-loading')
      },
      async onClickUpdate(id) {
        await this.$refs.updateNotificationManagePopUp.openPopup(id)
      },
      handleChangePage(page) {
        this.page = page;
        this.fetchNotificationManageList()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchNotificationManageList()
    },
    mixins: [SuccessMessage, ErrorMessages],
    watch: {
      page() {
        this.fetchNotificationManageList()
      },
      perPage() {
        this.fetchNotificationManageList()
      }
    }
  }
</script>

<style scoped>

</style>
